export default function CTASection() {
  return (
    <section className="relative h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20warm%20toned%20product%20photography%20flat%20lay%20of%20premium%20fashion%20and%20lifestyle%20accessories%20including%20a%20cognac%20leather%20bag%20a%20pair%20of%20cream%20sneakers%20a%20gold%20watch%20and%20a%20soft%20wool%20scarf%20arranged%20artistically%20on%20a%20rich%20terracotta%20toned%20linen%20surface%20with%20golden%20hour%20sunlight%20casting%20warm%20dramatic%20shadows%20elegant%20Italian%20editorial%20aesthetic%20rich%20earthy%20tones%20warm%20inviting%20atmosphere&width=1800&height=1200&seq=cta-bg-v2&orientation=landscape"
          alt="Acquista su Itaobuy Spreadsheet"
          title="Acquista su Itaobuy Spreadsheet"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/35"></div>
      </div>

      <div className="relative z-10 text-center px-6">
        <h2 className="text-background-50 font-heading text-4xl md:text-6xl lg:text-7xl font-bold tracking-wider mb-6">
          ACQUISTA ORA SU
          <br />
          <span className="text-accent-400">ITAOBUY</span>
        </h2>
        <p className="text-background-50/80 text-base md:text-lg max-w-lg mx-auto mb-10 leading-relaxed">
          Accedi alle risorse complete e ai fogli di calcolo
          <br />
          aggiornati per lo shopping internazionale.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 bg-background-50 text-foreground-950 rounded-full text-sm font-bold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
        >
          <span className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center">
            <i className="ri-shopping-bag-line text-background-50 text-base"></i>
          </span>
          BUY IT NOW
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}